import $axios from '@/core/api-config'

class HeadquartersService {
  getAll () {
    return $axios.get('/api/announcements')
  }

  create ({ title, subTitle }) {
    return $axios.post('/api/announcements', { title, subTitle })
  }

  update ({ title, subTitle, id }) {
    return $axios.put(`/api/announcements/${id}`, { title, subTitle })
  }

  delete (id) {
    return $axios.delete(`/api/announcements/${id}`)
  }
}

export const headquartersService = new HeadquartersService()
